export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8582.b22a446e.jpg";